import React from "react";
import { createRoot } from "react-dom/client";
import App from './Components/App';
// import Test from "./Components/Test";
// import Login from "./Components/Login";


const root = createRoot(document.getElementById("root"));
root.render(<App />);
